(function () {
  var button = document.querySelector('[data-back-to-top]');
  if (!button) return;

  var SHOW_AFTER_PX = 600;
  var ticking = false;

  var update = function () {
    ticking = false;
    var isVisible = window.scrollY > SHOW_AFTER_PX;
    if (isVisible) {
      button.hidden = false;
      requestAnimationFrame(function () { button.classList.add('is-visible'); });
    } else {
      button.classList.remove('is-visible');
    }
  };

  button.addEventListener('transitionend', function () {
    if (!button.classList.contains('is-visible')) button.hidden = true;
  });

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });

  update();

  button.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
